import {CSSProperties, useEffect, useMemo, useRef, useState} from "react";
import {AdvertisementAction} from "../../state/types";
import {useRefresh} from "../useRefresh";
import {Summary} from "./maxSize";
import {Skippy} from "../skip";
import {PlayerElement, PlayerElementHandle} from "../PlayerElement";
import {useDispatch, useSelector} from "react-redux";
import {VastType} from "./getSources";
import {AppState} from "../../state";
import equals from "fast-deep-equal";
import Style from "../style.module.scss";

export const useVideo = (vast: VastType) => {

    const maxSize = useSelector((state: AppState)=> (state.maxSize), equals);
    const dispatch = useDispatch();

    const vPlayer = useRef<PlayerElementHandle>(null);
    const timeUpdate = useRef<ReturnType<typeof setTimeout>>();
    const videosources = useMemo(() => {

        const width = maxSize.width;
        const height = maxSize.height;

        if (vast === "NONE") {
            return false;
        }

        let isJs = false
        const current = Math.sqrt(width * width + height * height);
        const videos = vast.sources.filter(i => (
            i && i.type.indexOf("ogv") === -1 && i.type.indexOf("ogg") === -1 && i.type.indexOf("flv") === -1
        )).map(i => {
            if (i.type === 'application/javascript') {
                isJs = true;
                return {...i, name: '', vzdalenost: 10000000};
            }


            return {
                ...i,
                name: i.width + "x" + i.height,
                vzdalenost: Math.abs(Math.sqrt(i.width * i.width + i.height + i.height) - current),
            }
        });

        if (isJs || videos.length === 0) {
            return false;
        }

        let name = '';

        return videos.sort((a, b) => {
            return a.vzdalenost - b.vzdalenost
        }).filter((a) => {
            if (!name || name === a.name) {
                name = a.name;
                return true;
            }
            return false;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vast]);

    const hasAdv = !(!videosources || vast === "NONE");
    useRefresh(hasAdv);
    const [duration, setDuration] = useState(-1);
    useMemo(() => {
        if (timeUpdate.current) {
            clearTimeout(timeUpdate.current);
        }
        timeUpdate.current = undefined;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasAdv])
    const [started, setStared] = useState(false);
    const [played, setPlayed] = useState(false);

    useEffect(() => {
        setDuration(-1);
        setStared(false);
        setPlayed(false);
        // eslint-disable-next-line
    }, [hasAdv])

    if (!hasAdv)
        return false;

    const {
        width,
        height,
        left,
        top
    } = Summary(started ? videosources[0].width || 640 : 20, started ? videosources[0].height || 640 : 20, maxSize, 23) || {
        width: 640,
        height: 640,
        left: 0,
        top: 0
    };

    const containerStyle: CSSProperties = {
        width: width + 'px',
        height: height + 'px',
        left: left + 'px',
        top:  top + 'px',
    }

    if (!(duration || played) || width <= 20) {
        containerStyle.backgroundColor = "transparent";
    }

    const useVideoInner = () => (<div className={hasAdv ? Style.reklamaExternal  : ''} style={{position: 'fixed'}}>
        <Skippy top={top - 23} time={duration} onClick={() => {
            vast.tracker?.skip();
        }}/>
        <div key={'container'} className={Style.reklamaContainer} style={containerStyle}>{[
            <PlayerElement
                           poster={videosources.filter(x =>x.type.indexOf("image") > -1)[0]?.src}
                           key={'video'} preload={"metadata"} ref={vPlayer} width={videosources[0].width}
                           height={videosources[0].height}
                           position={0}
                           speed={1}
                           style={{
                               width: (width - 20) + 'px',
                               height: (height - 20) + 'px',
                               cursor: 'pointer'
                           }}
                           onClick={e => {
                               e.preventDefault();
                               vast.tracker?.click();
                           }}
                           onEnded={(e) => {
                               vast.tracker?.complete();
                               vast.tracker?.close();
                               dispatch<AdvertisementAction>({
                                   type: "AdvertisementEnd"
                               })
                           }}
                           onTimeUpdate={() => {
                               vast.tracker?.trackImpression();
                               const cur = vPlayer.current?.currentTime
                               if (cur !== undefined) {
                                   vast.tracker?.setProgress(cur);
                                   if (!played && cur) {
                                       setPlayed(true);
                                       dispatch<AdvertisementAction>({
                                           type: "AdvertisementPlay"
                                       });
                                   }
                               }
                           }}
                           onError={(e) => {
                               dispatch<AdvertisementAction>({
                                   type: "AdvertisementError",
                                   payload: 'ERROR_MEDIA_PLAY ' + e.nativeEvent.type
                               })
                           }}
                           onLoadedMetadata={e => {
                               setStared(true);
                               const duration = vPlayer.current?.duration;
                               if (duration) {
                                   setDuration(duration);
                                   vast.tracker?.setDuration(duration);

                               } else {
                                   setDuration(0)
                               }
                           }}
                           sources={videosources.map((i, k) => ({src: i.src, type: i.type}))}
            />]}
        </div>
    </div>);

    return useVideoInner;
}